export const commonPostHeaders = new Headers({
  "content-type": "application/json",
});

export const baseUrl = "https://staff-workplace.pages.dev/api/";
